import { IEvent, IToken, Pagination } from '@/types'

export interface Vault {
  id: number
  token: IToken
  amount: number
  vaultAddress: string
  vaultExpiredAt: number
}

export interface VaultFilter {
  token: TokenFilterOption
  address: DepositWalletFilterOption
}

export interface TokenFilterOption {
  label: string
  value: string
  tokenLogoUri?: string
}

export interface DepositWalletFilterOption {
  label: string
  value: string
  wallet?: any
}

export interface DepositStatusFilterOption {
  label: string
  value: string
}

export enum DepositStatus {
  INIT = 'INIT',
  WAITING_CONFIRMATION = 'WAITING_CONFIRMATION', // deposited, waiting for mpc confirmed
  DEPOSITED = 'DEPOSITED', // mpc confirmed
  DEPOSIT_FAILED = 'DEPOSIT_FAILED', // failed to deposit

  TIMEOUT_NO_DEPOSIT = 'TIMEOUT_NO_DEPOSIT', // timeout no deposit, script timeout reach
  TIMEOUT = 'TIMEOUT', // deposit confirmed, script timeout reach
  PRE_REFUND = 'PRE_REFUND', // pre-refund event created, to show loading state in UI (unlocking vault)
  REFUNDED = 'REFUNDED', // after timeout, has refund confirmed event
  PROCESSING_SWAP = 'PROCESSING_SWAP', // processing swap, dont allow to submit new trade
  SWAP_FAILED = 'SWAP_FAILED', // swap failed, dont allow to submit new trade
  SWAP_COMPLETED = 'SWAP_COMPLETED', // made swap successfully

  // Across deposit
  SUBMIT_TO_BE = 'SUBMIT_TO_BE', // only for Across deposit
}

// dont move order of enum, they has a value number
export enum CreateVaultStep {
  INIT, // 0
  SUBMIT_TO_BE,
  CLAIM_OWNERSHIP, // sign message
  APPROVE,
  WAITING_CONFIRM_SEND_TOKEN, // waiting click confirm send
  WAITING_CONFIRMATION, // sent. waiting for deposit confirmed
  VAULT_CREATED,
  PROCESSING_SWAP,
  SWAP_FAILED,
  TIMEOUT,
  PRE_REFUND,
  REFUNDED,
  DONE, // refunded or swap completed
}

export interface IVaultDeposit {
  depositId: string
  depositTx: string
  solverAddress: string
  sessionId: string
  amountIn: string
  tradeId?: string
  fromUserAddress: string
  fromTokenId: string
  toTokenId?: string
  depositVault: string
  userEphemeralAssetChainPubkey: string
  userEphemeralL2Address: string
  mpcAssetChainPubkey: string
  userRefundPubkey: string
  scriptTimeout: number
  refundPresign: any
  status: DepositStatus
  createdAt: string
  events: Array<
    IEvent & {
      depositId: string
      inputData: {
        txId?: string
        timestamp?: number
        to?: string
        mpc?: string
        from?: string
        signature?: string
        depositFromList?: string[]
        transactionHash?: string
      }
    }
  >
}
export interface IVaultHistoryRes {
  data: IVaultDeposit[]
  paging: Pagination
}
